var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"list__item"},[_c('feather-icon',{staticClass:"w-5 h-5 mr-1",attrs:{"icon":_vm.rtlSpecificIcon}}),_c('span',{domProps:{"innerHTML":_vm._s(item)}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }